import { CDashboardModuleTabComponent, ComponentProps, Context, PageContext } from "../types";
import { useContext, useMemo } from "react";
import DashboardComponent from "./DashboardComponent";
import DashboardPageContext from "../DashboardPageContext";
import DashboardEnvContext from "../DashboardEnvContext";

function Component({ component, evaluteScript }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const dashboard = useContext(DashboardEnvContext);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { context, params, updateContext, activatePageLoader } = useContext(DashboardPageContext);

	const list = useMemo(() => {
		const list = evaluteScript(component.properties["binding"]) as CDashboardModuleTabComponent[];
		return list;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, context]);

	return (
		<>
			{list &&
				component.childern &&
				component.childern.length > 0 &&
				list &&
				list.map((item: CDashboardModuleTabComponent, i: number) => {
					const newContext = { ...context };
					newContext[component.properties["variable"]] = i;
					return (
						<DashboardPageContext.Provider
							key={i}
							value={{
								context: newContext,
								params: params,
								activatePageLoader: activatePageLoader,
								updateContext: (newValue: Context) => updateContext(newValue) as PageContext,
							}}
						>
							<DashboardComponent component={component.childern[0]} />
						</DashboardPageContext.Provider>
					);
				})}
		</>
	);
}

export default Component;
